<template>
    <div class="container-fluid" >
        <div class="card" v-if="loadedd">

            <div class="card-body" v-if="hasTelemetry">

                <div class="row">
                    <div class="col-md-12 text-end">
                        <a class="btn btn-primary m-1 border" @click="changeMode('card')">
                            <font-awesome-icon :icon="['fas', 'table']" style="color: white;"/>
                        </a>
                        <a class="btn btn-primary m-1" @click="changeMode('list')">
                            <font-awesome-icon :icon="['fas', 'list-ul']" style="color: white;"/>
                        </a>
                    </div>
                </div>
                <div v-if="mode === 'card'">
                    <div class="accordion">
                        <div class="accordion-item mb-3" v-for="(tanks, customerName, customerId) in groupedByCustomer"
                             :key="customerId">
                            <h2 class="accordion-header" :id="'heading' + customerId">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        :data-bs-target="'#collapse' + customerId" aria-expanded="false"
                                        :aria-controls="'collapse' + customerId">
                                    {{ customerName }}
                                </button>
                            </h2>
                            <div :id="'collapse' + customerId" class="accordion-collapse collapse"
                                 :aria-labelledby="'heading' + customerId">
                                <div class="accordion-body row">
                                    <div class="col-lg-2 col-md-3 col-sm-5 coluna-custom" v-for="(card, index) in tanks"
                                         :key="'card' + index">
                                        <CardTank :value="card" :is-favorite="!!card.favorite"
                                                  @changeAlert="changeAlert"
                                                  @removeFavorite="removeFavorite" @addFavorite="addFavorite"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" v-else>
                    <div class="live-preview">
                        <div class="table-responsive">
                            <table class="table table-hover table-nowrap align-middle mb-0">
                                <thead>
                                <tr>
                                    <th class="text-center">Tag Tanque</th>
                                    <th class="text-center">Produto</th>
                                    <th class="text-center">Nível/Capacidade</th>
                                    <th class="text-center">%</th>
                                    <th class="text-center">Status</th>
                                    <th class="text-center">Data Atualização</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr class="middle" v-for="(card, index) in tanksDataList" :key="'table-row' + index">
                                    <TableTank :value="card" :is-favorite="!!card.favorite"
                                               @removeFavorite="removeFavorite"
                                               @addFavorite="addFavorite"/>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="card-body">
                <div class="alert alert-info">
                    Serviço de Telemetria Indisponível
                </div>
                <h4>Olá {{ $store.getters.user.name }}!</h4>
                <p>
                    Você ainda não possui acesso ao serviço de telemetria da BAUMINAS.
                    Com esse módulo, você poderá monitorar em tempo real o nível dos tanques de seus produtos químicos,
                    acompanhando pontos de recarga ou níveis críticos.
                    <br>
                    Assim, será possível planejar o momento ideal para realizar
                    novas compras, garantindo eficiência e evitando interrupções.

                    <br>
                    <br>
                    Entre em contato com nosso time comercial para saber mais e contratar esse serviço.
                </p>
            </div>
        </div>
        <div v-else class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <div class="card-body text-center">
                            <span class="fa fa-spinner fa-spin fa-5x"></span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <div id="critical-level-modal">
        <div class="modal-fade-background"></div>
        <div :class="['modal fade show']" id="modal-pending" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">

                    <div class="modal-header bg-warning text-dark">
                        <h5 class="modal-title" id="criticalStockModalLabel">
                            <i class="bi bi-exclamation-triangle-fill"></i> Atenção
                        </h5>
                        <button type="button" @click="closeModal()" class="btn-close"></button>
                    </div>
                    <div class="modal-body text-center">
                        <p>
                            ⚠️ Alguns tanques estão com nível crítico!
                        </p>
                        <p>
                            Para evitar a interrupção no fornecimento, acesse a tela de pedidos e reponha seu estoque.
                            <br>
                            Caso não tenha contrato vigente para o produto, entre em contato com o comercial.
                        </p>

                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th>Tanque</th>
                                <th>Produto</th>
                                <th>Un. Medida</th>
                                <th>Capacidade</th>
                                <th>Nível Atual</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="tank in this.criticalTanks">
                                <td>{{ tank.tag }}</td>
                                <td>{{ tank.content }}</td>
                                <td>{{ tank.unit }}</td>
                                <td>{{ tank.capacity }}</td>
                                <td>{{ toBrNumber(tank.currentVolume) }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer justify-content-center">
                        <button type="button" class="btn btn-primary" @click="$router.push('/admin/order-new')">
                            Novo Pedido
                        </button>
                    </div>

                </div>

            </div>
        </div>
    </div>

</template>

<script>
import CardTank from "./CardTank.vue";
import TanksData from './Models/TankModel';
import {ref, onMounted} from "vue";
import env from "@/env";
import {useStore} from "vuex";
import TableTank from "@/components/Telemetry/TableTank.vue";
import TankModel from "./Models/TankModel";
import {floatToDecimal} from "./Dependencies/functions";

export default {
    page: {
        title: "Dashboard",
    },
    components: {
        TableTank,
        CardTank,
    }, data() {
        return {
            loadedd: false,
            hasTelemetry: false,
            mode: "card",
            groupedByCustomer: {},
            tanksDataList: [],
            hasTankInCriticalLevel: false
        };
    },
    computed: {
        criticalTanks() {
            return this.tanksDataList.filter(item => item.critical)
        }
    },
    methods: {
        toBrNumber(value) {
            if (value == 0) {
                return value
            } else if (value && parseFloat(value) !== 'NaN') {
                const convert = new Intl.NumberFormat('pt-BR', {style: 'decimal', minimumFractionDigits: 2});

                return convert.format(value.toFixed(2));
            } else {
                return '';
            }
        },
        closeModal() {
            close_modal("critical-level-modal")
        },
        async getTanqueApi() {
            try {
                let self = this
                const token = localStorage.getItem("token");
                if (!token) throw new Error("Token não encontrado!");

                const headers = new Headers({
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                });

                const customer_id = this.store.getters.user.customer_id;
                const response = await fetch(`${env.api}tanques?customer_id=${customer_id}`, {
                    method: "GET",
                    headers,
                });

                if (response.status !== 200) {
                    throw new Error(`Erro na API: ${response.statusText}`);
                }

                const json = await response.json();

                if (!Array.isArray(json)) {
                    throw new Error("A API não retornou um array de dados.");
                }

                const tanks = json.map((item) => new TankModel(item));
                this.tanksDataList = tanks;

                this.tanksDataList.forEach(tank => {
                    if (tank.criticalLevel > tank.currentVolume) {
                        this.hasTankInCriticalLevel = true
                        tank.critical = true

                        // aguarda antes de abrir o modal
                        window.setTimeout(function () {
                            show_modal("critical-level-modal");
                        }, 2000)
                    }
                });

                // show_modal("critical-level-modal");

                if (tanks.length > 0) {
                    this.hasTelemetry = true;
                }

                this.groupedByCustomer = tanks.reduce((groups, tank) => {
                    const {customerName} = tank;
                    if (!groups[customerName]) {
                        groups[customerName] = [];
                    }
                    groups[customerName].push(tank);

                    return groups;
                }, {});
            } catch (error) {
                console.error("Erro ao buscar tanques:", error.message);
            } finally {
                this.loadedd = true;
            }
        },
        changeMode(newMode) {
            this.mode = newMode;
        },
    },
    mounted() {
        this.store = useStore(); // Inicializa o Vuex store
        this.getTanqueApi();
    },
}

</script>
<style>
.modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.modal-body p {
    margin-bottom: 10px;
    font-size: 1rem;
    line-height: 1.5;
}

.modal-footer {
    padding-top: 0;
}

.accordion-header {
    border-style: solid;
    border-color: lightgray;
    border-width: 0.1rem;
}

@media (max-width: 767px) {

    /* Tela pequena */
    .coluna-custom {
    }
}

@media (min-width: 768px) and (max-width: 991px) {

    /* Tela média */
    .coluna-custom {
        min-width: 220px;
    }
}

@media (min-width: 992px) {

    /* Tela grande */
    .coluna-custom {
        min-width: 220px;
    }
}
</style>
